import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';

import { Dialog } from './dialog.model';
import { ModalDialogService } from './modal-dialog.service';

@Component({
    selector: 'app-modal-dialog',
    templateUrl: './modal-dialog.component.html',
    styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit, OnDestroy {
    currentDialog: Dialog = null;
    private dialogSubscription: Subscription;

    constructor(
        private modalDialogService: ModalDialogService,
        private renderer: Renderer2
    ) { }

    closeAlert() {
        this.modalDialogService.setModalDialog(null);
    }

    ngOnInit() {
        this.dialogSubscription = this.modalDialogService.getModalDialog().subscribe(dialog => {
            this.currentDialog = dialog;
            const pageContentBlock = document.getElementById('pageContent');
            if (dialog) {
                this.renderer.addClass(pageContentBlock, 'modal-open');
                this.renderer.setStyle(document.body, 'overflow', 'hidden');
            } else {
                this.renderer.removeClass(pageContentBlock, 'modal-open');
                this.renderer.setStyle(document.body, 'overflow', 'auto');
            }
        });
    }

    ngOnDestroy() {
        this.dialogSubscription.unsubscribe();
    }
}
